'use strict';

intellidealerAppEquipmentModule.config(['$stateProvider', function ($stateProvider) {
  $stateProvider.state(
    'navigation.equipment.equipmentForSale.equipmentForSaleDetails.differential', {
      url: '/differential',
      templateUrl: 'app/scripts/modules/equipment/views/differential.html'
    }
  );

  $stateProvider.state(
    'public.equipment.equipmentForSale.equipmentForSaleDetails.differential', {
      url: '/differential',
      templateUrl: 'app/scripts/modules/equipment/views/differential.html'
    }
  );
}]);
